import { LobbyImage } from '@colonist/types';
import { UIMMatchmakingSearchingView } from './UIMMatchmakingSearchingView.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
export class UIMMatchmakingSearchingRush4PView extends UIMMatchmakingSearchingView {
    addTitle() {
        super.addTitle();
        this.setTimeElapsedCounter();
    }
    constructor(matchmakingController){
        const loadingText = {
            key: 'strings:homePage.matchmakingPopup.searchingForOpponents'
        };
        const title = {
            key: 'strings:homePage.matchmakingPopup.rankedRush.title'
        };
        const imageSrc = LobbyImage.GameModeRankedRush;
        super(matchmakingController, title, imageSrc, loadingText, MatchmakingMatchTypes.RankedRush4P);
    }
}
